import { User as PBUser, User_Type } from "gen/user/models_pb"

import { ensure } from "../../utils/nullish/nullish"
import { UUID } from "../uuid"

export function attributionName(
  user: Pick<PBUser, "attributionStaff" | "name"> | undefined
): string | undefined {
  return user?.attributionStaff?.name || user?.name
}

export class User {
  private user: PBUser

  private constructor(user: PBUser) {
    this.user = user
  }

  static fromPB(pbUser: PBUser) {
    return new User(pbUser)
  }

  static fromPBOrThrow(pbUser?: PBUser, message = "Missing User"): User {
    return User.fromPB(ensure(pbUser, message))
  }

  get id(): UUID {
    switch (this.user.type) {
      case User_Type.USER_TYPE_STAFF:
        return UUID.fromPBOrThrow(this.user.staffId)
      case User_Type.USER_TYPE_DOOER_STAFF:
        return UUID.fromPBOrThrow(this.user.dooerStaffId)
      default:
        throw new Error(`unexpected user type: ${this.user.type}`)
    }
  }

  get displayName(): string {
    switch (this.user.type) {
      case User_Type.USER_TYPE_STAFF:
        return (
          this.user.attributionStaff?.name || this.user.name || "Staff Member"
        )
      default:
        return "Rundoo Team"
    }
  }
}
